import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { isEncounterScheduleSubmitted } from "../helpers/encounter-schedule-status.util";
import { DataService } from "./data.service";

/** API value for biller claim status "Sent". */
export const BILLER_CLAIM_STATUS_SENT_API = "draft";

@Injectable({
  providedIn: "root",
})
export class EncounterClaimStatusSyncService {
  private readonly apiBaseUrl = environment.apiBaseUrl;

  constructor(private readonly _dataService: DataService) {}

  /**
   * When schedule status is Submitted, set claimStatus to draft (biller "Sent").
   * Overwrites any prior claim status (e.g. after Redacted).
   */
  ensureDraftWhenSubmittedIfClaimStatusEmpty(
    encounterId: string | undefined,
    scheduleStatus: string | undefined,
    _sources: unknown[] = []
  ): Observable<void> {
    if (!encounterId || !isEncounterScheduleSubmitted(scheduleStatus)) {
      return of(void 0);
    }
    return this.patchSentClaimStatus(encounterId);
  }

  private patchSentClaimStatus(encounterId: string): Observable<void> {
    const url =
      this.apiBaseUrl +
      `api/v1/encounters/${encodeURIComponent(encounterId)}/claim-status`;
    return this._dataService
      .patch(url, { claimStatus: BILLER_CLAIM_STATUS_SENT_API })
      .pipe(
        map(() => void 0),
        catchError(() => of(void 0))
      );
  }
}
